import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';

import { ChartsModule } from 'ng2-charts-x';

import { VehicleServiceProvider } from '../providers/servicer/vehicle-service';
import { SimulateServiceProvider } from '../providers/servicer/simulate-service';
import { SystemDashboardServiceProvider } from '../providers/servicer/system-dashboard-service';
import { LoadingProvider } from '../providers/loading/loading';
import { SystemSessionServiceProvider } from '../providers/servicer/system-session-service';
import { InputFormProvider } from '../providers/input-form/input-form';
import { SystemMaintOptionsServiceProvider } from '../providers/servicer/system-maint-options-service';
import { SystemMaintStopPointsServiceProvider } from '../providers/servicer/system-maint-stop-points-service';
import { SystemMaintUsersServiceProvider } from '../providers/servicer/system-maint-users-service';
import { SystemMaintAreasServiceProvider } from '../providers/servicer/system-maint-areas-service';
import { SystemMaintVehiclesServiceProvider } from '../providers/servicer/system-maint-vehicles-service';
import { SystemVehicleOperationServiceProvider } from '../providers/servicer/system-vehicle-operation-service';
import { SystemRestPlanServiceProvider } from '../providers/servicer/system-rest-plan-service';
import { SystemWaitPointPlanServiceProvider } from '../providers/servicer/system-wait-point-plan-service';
import { ServicerProvider } from '../providers/servicer/servicer';
import { SystemDashboardIntervalReceiverProvider } from '../providers/system-dashboard-interval-receiver/system-dashboard-interval-receiver';
import { SystemRestPlanDashboardIntervalReceiverProvider } from '../providers/system-rest-plan-dashboard-interval-receiver/system-rest-plan-dashboard-interval-receiver';
import { IntervalReceiverProvider } from '../providers/interval-receiver/interval-receiver';
import { SystemChargePlanServiceProvider } from '../providers/servicer/system-charge-plan-service';

import { LoginComponentModule } from '../components/login/login.module';
import { CustomLoadingComponentModule } from '../components/custom-loading/custom-loading.module';

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    ChartsModule,
    HttpClientModule,
    LoginComponentModule,
    CustomLoadingComponentModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    DatePipe,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    SimulateServiceProvider,
    VehicleServiceProvider,
    SystemDashboardServiceProvider,
    LoadingProvider,
    SystemSessionServiceProvider,
    InputFormProvider,
    ServicerProvider,
    SystemMaintOptionsServiceProvider,
    SystemMaintStopPointsServiceProvider,
    SystemMaintUsersServiceProvider,
    SystemMaintAreasServiceProvider,
    SystemMaintVehiclesServiceProvider,
    SystemVehicleOperationServiceProvider,
    SystemDashboardIntervalReceiverProvider,
    SystemRestPlanDashboardIntervalReceiverProvider,
    SystemRestPlanServiceProvider,
    SystemWaitPointPlanServiceProvider,
    IntervalReceiverProvider,
    SystemChargePlanServiceProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts